export const getAddressSelectionCoordinates = (addressData: Record<string, any> | null | undefined) => {
  if (!addressData) return null;

  const rawLat =
    addressData.latitude ??
    addressData.lat ??
    addressData?.geometry?.location?.lat ??
    addressData?.location?.lat;
  const rawLng =
    addressData.longitude ??
    addressData.lng ??
    addressData?.geometry?.location?.lng ??
    addressData?.location?.lng;

  const lat = rawLat != null ? Number(rawLat) : NaN;
  const lng = rawLng != null ? Number(rawLng) : NaN;

  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;

  return { lat, lng };
};

export const normalizeAddressSelectionData = (addressData: Record<string, any> | null | undefined) => {
  if (!addressData) return null;

  const coords = getAddressSelectionCoordinates(addressData);
  if (!coords) return addressData;

  return {
    ...addressData,
    lat: coords.lat,
    lng: coords.lng,
    latitude: coords.lat,
    longitude: coords.lng,
  };
};
